// extracted by mini-css-extract-plugin
export default {"container":"CalcEmptyListBlock_container__kBFf+","empty":"CalcEmptyListBlock_empty__EEEue"};